/**
 * form.js
 *
 * Generic mixin handle default forms...
 *
 * @author     Ken van den Broek    <k.vandenbroek@uselab.com>
 * @copyright  2019 Uselab.com
 *
 */

import objectHelper from 'app/helpers/object'

export default {
  data () {
    return {
      data: {},
      focused: ''
    }
  },
  methods: {
    get (key) {
      if (typeof this.data.form === 'undefined') return ''

      const value = objectHelper.get(key, this.data.form)

      return typeof value === 'undefined' ? '' : value
    },
    toggleClass (key) {
      if (this.focused === key) {
        return 'form-group--focus'
      } else {
        if (typeof this.v$.form[key] !== 'undefined') {
          // added to display back-end validations (eigenhaard)
          if (Object.prototype.hasOwnProperty.call(this.v$.form[key], 'apiValidated')) {
            if (this.v$.form[key].apiValidated === false) {
              return 'form-group--error'
            }
          }

          if (this.v$.form[key].$dirty && this.v$.form[key].$error) {
            return 'form-group--error'
          }
        }
      }
    },
    toggleFocus (type, key) {
      this.focused = (type === 'focus' ? key : '')
    }
  }
}
